import { Button } from '../../atoms/Button';
import { Typography } from '../../molecules/Typography';
import { getSalesLink } from '../../../accessControl/salesLink';

interface IRouteBlockModal {
  /** Chamado ao fechar / voltar. Deve levar o usuário para /minha-area. */
  onBack: () => void;
  /** Rótulo do botão secundário. Padrão: "Voltar para Minha Área". */
  backLabel?: string;
  /** Módulos liberados do aluno, usados para escolher o link de upsell. */
  platformModules?: string[] | null;
}

export default function RouteBlockModal({
  onBack,
  backLabel = 'Voltar para Minha Área',
  platformModules,
}: IRouteBlockModal) {
  const goToSales = () => {
    window.open(getSalesLink(platformModules), '_blank');
  };

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center p-4'>
      <div className='w-full max-w-screen-sm rounded-lg bg-color-lightest shadow-level-4 xs:w-full md:w-2/5'>
        <div className='flex flex-col items-center px-4 py-8'>
          <Typography
            size='h4'
            weight='bold'
            className='mt-4 px-2 text-center text-base text-brand-color-primary-pure'
          >
            Quer ir além?
          </Typography>
          <Typography className='mb-8 mt-4 px-2 text-center text-brand-color-primary-pure'>
            Desbloqueie todos os recursos da Aprova Total e tenha uma
            experiência completa.
          </Typography>
          <Button full onClick={goToSales}>
            Quero ter acesso
          </Button>
          <Button
            full
            variant='outlined'
            className='mt-3'
            onClick={onBack}
            allowReadOnly
          >
            {backLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
